export default __webpack_public_path__ + "static/media/guide0104_m.e63b6358.jpg";